/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import xss from 'xss';

import Editor from '@qality/common-components/src/editor';
import { StringUtils } from '@qality/common-utils';

import './style.css';

const XSSOptions = {
  whiteList: {
    a: ['data-style', 'href', 'rel', 'tabIndex'],
    b: [],
    strong: [],
    p: [],
    u: [],
    em: [],
    span: ['class'],
    strike: [],
    ul: [],
    li: [],
    ol: [],
    br: [],
  },
};

export default class InlineEdit extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    onBlur: PropTypes.func,
    onClick: PropTypes.func,
    onConfirm: PropTypes.func,
    maxHeight: PropTypes.string,
    text: PropTypes.string,
    length: PropTypes.number,
    label: PropTypes.string,
    shouldLoadToolbar: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.maxHeight = this.props.maxHeight ? this.props.maxHeight : '15em';
    this.state = {
      text: this.sanitizeHTML(props.text),
      mode: 'read',
      isInvalid: false,
      isFocused: false,
      originalText: '',
    };
  }

  sanitizeHTML(text: string) {
    if (text) {
      return xss(text, XSSOptions)
        .replace(/<a[^>]*/g, (match) => {
          const handledAttributes = match
            .split(' ')
            .filter((matchText) =>
              XSSOptions.whiteList.a.some((tag) => matchText.startsWith(tag))
            );
          return `<a tabIndex='-1' ${handledAttributes
            .filter(Boolean)
            .sort()
            .join(' ')} target="_blank"`;
        })
        .replace(/rel='nofollow'/g, "rel='nofollow noopener noreferrer'");
    }
    return xss(text, XSSOptions);
  }

  onClick = (e) => {
    if (e.target?.nodeName !== 'A') {
      this.setState({
        mode: 'edit',
        isFocused: true,
      });
    }
  };

  handleClick = () => {
    if (!this.state.isFocused) {
      this.setState({
        mode: 'edit',
        isFocused: true,
      });
    }
  };

  handleBlur = () => {
    if (
      this.props.length &&
      StringUtils.getByteLength(this.state.text) > this.props.length
    ) {
      this.setState({
        isInvalid: true,
        mode: 'read',
        isFocused: false,
      });
    } else {
      this.props.onConfirm(
        this.state.text,
        this.state.text !== this.state.originalText
      );
      this.setState({
        mode: 'read',
        isInvalid: false,
        isFocused: false,
      });
    }
  };

  // eslint-disable-next-line complexity
  getReadModeContent = () => {
    const readClassName =
      'inline-edit-read ' + (this.state.isInvalid ? 'inline-edit-invalid' : '');

    if (
      StringUtils.isNilOrEmpty(this.state.text) &&
      !StringUtils.isNilOrEmpty(this.props.placeholder)
    ) {
      return (
        <>
          <div
            tabIndex={0}
            onFocus={this.onClick}
            className={readClassName}
            style={{ maxHeight: this.maxHeight, minHeight: '2em' }}
            onClick={this.onClick}
          >
            <p className='inline-edit-placeholder'>{this.props.placeholder}</p>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div
            tabIndex={0}
            onFocus={this.onClick}
            dangerouslySetInnerHTML={{ __html: this.state.text }}
            className={readClassName}
            style={{ maxHeight: this.maxHeight, minHeight: '2em' }}
            onClick={this.onClick}
          ></div>
          {this.state.isInvalid && (
            <div className='inline-edit-error'>
              Maximum characters allowed {this.props.length} has been exceeded.
            </div>
          )}
        </>
      );
    }
  };

  onChange = (value) => {
    this.setState({
      text: value,
    });
  };

  setOriginalText = (value) => {
    this.setState({
      originalText: value,
    });
  };

  getEditModeContent = () => {
    return (
      <Editor
        isDisabled={false}
        value={this.state.text}
        onBlur={this.handleBlur}
        onClick={this.handleClick}
        onChange={this.onChange}
        isFocused={this.state.isFocused}
        listEnabled={true}
        shouldLoadToolbar={this.props.shouldLoadToolbar}
        setOriginalText={this.setOriginalText}
      />
    );
  };

  render() {
    return (
      <div className='inline-edit-wrapper'>
        {this.props.label && (
          <div className='inline-edit-label'>{this.props.label}</div>
        )}
        {this.state.mode === 'read'
          ? this.getReadModeContent()
          : this.getEditModeContent()}
      </div>
    );
  }
}
